<template>
    <v-card>
        <v-form ref="form" v-model="form">
        <v-card-title>
            Éditer utilisateur {{user.username}}
        </v-card-title>
        <v-card-text class="text-left">
            <v-text-field
            class="my-5"
            label="Nom d'utilisateur"
            v-model="username"
            outlined
            :rules="[rules.required, rules.username]"
            :error-messages="messages.username"
            type="text"
            dense
            persistent-hint hint="Le nom d'utilisateur doit contenir au moins 3 caractères."
            ></v-text-field>
            <v-text-field
            class="my-5"
            label="Email"
            v-model="email"
            outlined
            :error-messages="messages.email"
            :rules="[rules.required, rules.email]"
            type="text"
            dense
            persistent-hint hint="Vous devez entrer un email valide."
            ></v-text-field>
            <p><b>Veuillez noter que l'utilisateur concerné sera informé de ce changement par un email.</b></p>
        </v-card-text>
        <v-card-actions class="py-5">
            <v-spacer></v-spacer>
            <v-btn
            color="primary darken-1"
            text
            @click="$emit('hide')"
            >
            Annuler
            </v-btn>
            <v-btn
            style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px; color:white;"
            @click="edit"
            >
            Editer
            </v-btn>
        </v-card-actions>
        </v-form>
        </v-card>
</template>
<script>
export default {
    name: 'edit-user',
    props: ['user'],
    data : ()=> ({
        email: '',
        username: '',
        form: false,
        rules: {
            required: value => !!value || 'Ce champs est obligatoire.',
            username: value =>{ 
                const pattern = /^[A-Za-z0-9]+$/
                return value.length >= 3 && pattern.test(value) || 'Le nom d\'utilisateur doit être composé au moins de 3 caractères alpha-numériques.'
            },
            password: value => value.length >= 8 || 'Le mot de passe doit contenir au moins 8 caractères.',
            email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Vous devez entrer un email valide.',
        },
        messages: {
            username: '',
            email: ''
        },
    }),
    mounted(){
        this.email = this.user.email
        this.username = this.user.username
    },
    methods: {
        edit(){
            this.messages = {
                    email: '',
                    username: ''
                }
            let data = {
                old: {
                    username: this.user.username,
                    email: this.user.email
                },
                username: this.username,
                email: this.email,
                id: this.user.id
            }
            if(this.$refs.form.validate()){
                this.axios.put('/user/update/login', data, {}).then((res) => {
                    if(res.data.error){
                        this.messages[res.data.error] = res.data.message
                    }else{
                        this.$emit('print_message', {color: 'success', text: 'Donnée(s) modifiée(s) avec succès.'})
                        this.$emit('hide')
                    }
                })
            }
        },
    }
}

</script>


// WEBPACK FOOTER //
// src/views/dashboard/users/actions/edit.vue